import { axios } from '@Api/axiosClient';

/**
 * Validates that a phone number is reachable via the Auth BFF's Twilio Lookup.
 *
 * Accepts either a full E.164 value (intl flag ON — AppTelInput emits E.164) or a
 * bare 10-digit US number (flag OFF — masked input); the BFF's LookupPhoneNumberUS
 * canonicalizes both before the Twilio call. The `+` is URL-encoded so it survives
 * the query string. Resolves to false on any error so callers fail closed.
 *
 * @param phoneNumber E.164 or 10-digit US phone number.
 * @returns true when the number is reachable (and, when the backend E.164 flag is off, US).
 */
export const validatePhoneNumberApi = async (phoneNumber: string): Promise<boolean> => {
    try {
        const response = await axios.get<boolean>(
            `/api/PhoneLookup/IsPhoneNumberValid?phoneNumber=${encodeURIComponent(phoneNumber)}`,
        );
        // Fail closed: only a literal `true` payload means reachable. A non-boolean body
        // (object/string) must not be coerced to "reachable".
        return response.data === true;
    } catch {
        return false;
    }
};
